require('core-js/es/string/starts-with');
require('core-js/es/string/ends-with');
require('core-js/es/object/keys');
require('core-js/es/object/values');
require('core-js/es/object/values');
require('core-js/es/object/');
require('core-js/es/number/parse-int');
require('core-js/es/parse-int');
require('react-app-polyfill/ie11');
require('react-app-polyfill/stable');
